import React from "react";
import {Alert} from "reactstrap";
import {connect} from "react-redux";
import ArchiveLink from "./ArchiveLink";
import {
    isCurrentNewsletterTemporary,
    getCurrentNewsletterGroupingId,
    getNewsletterArchiveDatesByGroupingId,
} from "../../../../redux/selectors/newsletters";

/**
 * output message if this is a temporary CL-04
 * link to most recent edition added if it exists
 * @param {} props
 * @param {Boolean} props.isTemporary - true if the newsletter is temp CL-04
 * @param {Array} props.archiveDateArray - 0-1 elements; *most recent* date for the newsletter
 * @return {}
 */
const FinalizedEditionAlert = (props) => {
    const {isTemporary, archiveDateArray} = props;

    if (isTemporary) {
        return (
            <Alert color="warning" className="m-3">
                <i className="fas fa-exclamation-triangle fa-lg m-2"></i>
                This is not a finalized edition of the newsletter.  <RecentLink archiveDateArray={archiveDateArray} />
            </Alert>
        )
    } else {
        return null;
    }
};

/**
 * return the addtional link to most recent CL-04 if we have one
 * @param  {Array} archiveDateArray - array of 0-1 elements; contains the *most recent* edition date
 * @return {}
 */
const RecentLink = ({archiveDateArray}) => {
    if (archiveDateArray.length) {
        const date = archiveDateArray[0];

        return (
            <span>
                <ArchiveLink className="alert-link" date={date}>Click here</ArchiveLink> to see the most recent one.
            </span>
        )
    } else {
        return null;
    }
};

/**
 * mapStateToProps returns the parts of the state that will be available as props
 * @param state
 * @returns {}
 */
const mapStateToProps = (state) => {
    const groupingId = getCurrentNewsletterGroupingId(state);
    return {
        isTemporary: isCurrentNewsletterTemporary(state),
        archiveDateArray: getNewsletterArchiveDatesByGroupingId(state, groupingId),
    };
};

/**
 * mapDispatchToProps exposes the actions we want to call as props
 * @param state
 * @returns {}
 */
const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(FinalizedEditionAlert);